export const DEPOSIT_ADDRESS = 'DEPOSIT_ADDRESS';

export const DEPOSIT_REQUEST = 'DEPOSIT_REQUEST';

export const CONTENTS_WALLET_LIST_REQUEST = 'CONTENTS_WALLET_LIST_REQUEST';
